import { Role } from '@typings/operations';
import { Option } from '@components/Formik/MultiSelectFilter/types';

export const reformatRolesToOptions = (
  roles: Pick<Role, 'id' | 'name' | 'isOfficer' | 'termLength'>[]
): Option[] =>
  roles
    .filter(role => role.isOfficer)
    .map(role => ({ id: role.id, value: role.name, label: role.name }));
